import { useGetDriversQuery, useGetVehiclesQuery } from '#api/resources.slice.ts';

export const useResources = () => {
    const { data: drivers, isLoading: driverLoading, refetch: refetchDrivers } = useGetDriversQuery();
    const { data: vehicles, isLoading: vehicleLoading, refetch: refetchVehicles } = useGetVehiclesQuery();

    return {
        isLoading: driverLoading || vehicleLoading,
        drivers: drivers || [],
        vehicles: vehicles || [],
        trailers: [],
        refetch: () => {
            refetchDrivers();
            refetchVehicles();
        },
    };
};
